<template>
  <div class="case-progress">
    <Row class="case-document-left">
      <!-- 材料导航栏 -->
      <Menu
        v-if="menuData.length > 0" :theme="theme2"
        accordion :active-name="type"
        @on-open-change="changeParentActive" @on-select="changeActive"
      >
        <Submenu
          v-for="item in menuData" :key="item.code"
          :name="item.code"
        >
          <template slot="title">
            <i class="icon-folder-01"></i>
            {{ item.name }}
          </template>
          <MenuItem
            v-for="menuitem in item.processNodeTreeList" :key="menuitem.code"
            :name="`${menuitem.code}-${menuitem.name}`"
          >{{ menuitem.name }}</MenuItem>
        </Submenu>
      </Menu>
    </Row>
    <Row class="case-progress-right">
      <Row class="detail-header">
        <span>{{ title }}</span>
      </Row>
      <Spin v-if="tableLoading" fix />
      <Table :columns="columns" :data="data" />
    </Row>
    <preview-file ref="perviewFile" />
  </div>

</template>

<script>
export default {
  components: {},
  props: ['caseId', 'projectId'],
  data() {
    return {
      data: [],
      tableLoading: false,
      theme2: 'light',
      title: '', // 列表名称
      parentType: '', // 当前展开一级菜单
      type: 'CM-项目协作材料', // 当前点击子类型
      menuData: [], // 分类列表数据
      columns: [
        {
          title: '文件名称',
          key: 'name',
          render: (h, params) => {
            return h('a', {
              class: 'textover',
              attrs: {
                title: params.row.name
              },
              on: {
                click: () => {
                  params.row.attachment ? this.$refs.perviewFile.preview(params.row.attachment)
                    : this.$refs.perviewFile.preview(params.row)
                }
              }
            }, params.row.name)
          }
        },
        {
          title: '上传时间',
          key: 'createTime',
          render: (h, params) => {
            const createTimeStr = this.common.formatTime(new Date(params.row.attachment ? params.row.attachment.createTime : params.row.createTime))
            return h('span', {
              class: 'textover',
              attrs: {
                title: createTimeStr
              }
            }, createTimeStr)
          }
        },
        {
          title: '上传人',
          key: 'uploader',
          render: (h, params) => {
            const createCreator = params.row.uploader
            return h('span', {
              class: 'textover',
              attrs: {
                title: createCreator
              }
            }, createCreator)
          }
        },
        {
          title: '操作',
          key: 'action',
          render: (h, params) => {
            let url = ''
            if (params.row && params.row.url && !params.row.attachment) {
              url = params.row.url
            } else if (params.row.attachment && params.row.attachment.url) {
              url = params.row.attachment.url
            }

            return h('span', {
              style: {
                color: '#3a5bae',
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  window.open(url)
                }
              }
            }, '下载')
          }
        }
      ]
    }
  },
  watch: {},
  created() {
    this.getProcessNode()
  },
  beforeMount() {},
  mounted() {
  },
  updated() {
  },
  methods: {
    // 选取文档类型
    changeActive(data) {
      const arr = data.split('-')
      this.type = data
      this.title = arr[1]
      this.getDocumentList()
    },
    // 当前展开一级菜单
    changeParentActive(data) {
      this.parentType = data[0]
    },
    // 获取文档类型
    getProcessNode() {
      const url = `/business/case/${this.caseId}/process-node`
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.menuData = res.data
          this.title = res.data[0].processNodeTreeList[0].name
          this.parentType = res.data[0].code
          this.getDocumentList()
        }
      })
    },
    // 获取当前类型的文档数据
    getDocumentList() {
      switch (this.parentType) {
        case 'project':
          // 案件材料
          this.getMaterialContent(this.type)
          break
        case 'case':
          // 办案材料
          this.getCaseContent('case')
          break

        default:
          break
      }
    },
    // 获取案件材料分类里具体的附件
    getMaterialContent(type) {
      const temp = type.split('-')[0]
      const url = '/business/materials/lawyer?projectId=' + this.projectId + '&type=' + temp
      this.tableLoading = true
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.data = res.data || []
        }
        this.tableLoading = false
      })
    },
    // 获取办案材料分类里具体的附件
    getCaseContent(data) {
      let temp = []
      this.menuData.forEach(item => {
        if (item.code === data) {
          temp = item.processNodeTreeList
        }
      })
      const url = '/business/case/document'
      const ajaxData = {
        caseType: '',
        code: '',
        processId: ''
      }
      temp.forEach(item => {
        if (this.type.includes(item.code)) {
          ajaxData.caseType = item.caseType
          ajaxData.code = item.code
          ajaxData.processId = item.processId
        }
      })
      this.tableLoading = true
      this.$get(url, ajaxData).then(res => {
        if (res.code == 0) {
          this.data = res.data || []
        }
        this.tableLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../case/caseProgress.scss';
@import '../civilCase/caseCommon.scss';
.case-document-left {
    // min-width: 280px;
    height: 100%;
    overflow-y: auto;
    float: left;
    border: 1px solid $borderColor;
    margin-right:10px;
    .ivu-menu-vertical.ivu-menu-light:after {
        width: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/case/caseDocument.vue